import React from "react";
import Typography from "@visa/vds/typography";
import Row from "@visa/vds/row";
import Badge from "@visa/vds/badge";
import MCSOverlayLoading from "components/MCSOverlayLoading";
import { useAuthContextUser } from "context/AuthContext";

const OrderOrganizationDetails = (props) => {
  let { displaySubscriptionManager, licensedBusinessPaymentInformation } = props
  const user = useAuthContextUser();

  if (licensedBusinessPaymentInformation == null) {
    return <MCSOverlayLoading />;
  } else {
    return (
      <>
        <Typography tag="h2">Payment</Typography>
        <Row>
          <Row>
            <Typography className="vss-field-label">
              <b>Payment Mode: </b>
              {licensedBusinessPaymentInformation && licensedBusinessPaymentInformation.isUVID && "Credit Card"}
              {licensedBusinessPaymentInformation && !licensedBusinessPaymentInformation.isUVID && "Bill to Visa BID"}
            </Typography>
          </Row>
          <Row>
            <Typography className="vss-field-label">
              <b>Billing Organization: </b>
              {licensedBusinessPaymentInformation &&
                licensedBusinessPaymentInformation.licensedCompanyName}
            </Typography>
          </Row>
          <Row>
            <Typography className="vss-field-label">
              <b>BID: </b>
              {licensedBusinessPaymentInformation
                && licensedBusinessPaymentInformation.bid} &nbsp;
              {licensedBusinessPaymentInformation && licensedBusinessPaymentInformation.isUVID && (
                <Badge type="neutral">UVID</Badge>
              )}
            </Typography>
          </Row>
          <Row>
            <Typography className="vss-field-label">
              <b>Country: </b>
              {licensedBusinessPaymentInformation
                && licensedBusinessPaymentInformation.licensedCountry}
            </Typography>
          </Row>
          <Row>
            <Typography className="vss-field-label">
              <b>Region: </b>
              {licensedBusinessPaymentInformation
                && licensedBusinessPaymentInformation.region}
            </Typography>
          </Row>
          {displaySubscriptionManager === true &&
            <Row>
              <Typography className="vss-field-label">
                <b>Subscription Manager: </b>
                {user.firstName + " " + user.lastName}
              </Typography>
            </Row>}
        </Row>
      </>
    );
  }
};

export default OrderOrganizationDetails;
